import type { LocationQuery, LocationQueryValue, RouteLocation, RouteParams, RouteParamValue } from "vue-router";
import { joinURL } from "ufo";

export interface RouteExtractionOptions {
  required?: boolean;
}

function ensureExists(value: string | null | undefined, name: string) {
  if (!value) {
    throw new Error(`Parameter ${name} was required but was not found.`);
  }
  return value;
}

type QueryOrRouteParam = RouteParamValue | RouteParamValue[] | LocationQueryValue | LocationQueryValue[] | undefined;

function resolveValue(value: QueryOrRouteParam, name: string, options: RouteExtractionOptions = {}) {
  const resolved = Array.isArray(value) ? value[0] : value;
  return options.required ? ensureExists(resolved, name) : resolved || undefined;
}

export function getRouteParam(params: RouteParams, name: string, options: RouteExtractionOptions & { required: true }): string;
export function getRouteParam(params: RouteParams, name: string, options?: RouteExtractionOptions): string | undefined;
export function getRouteParam(params: RouteParams, name: string, options?: RouteExtractionOptions) {
  const param = params[name];
  return resolveValue(param, name, options);
}

export function getQueryParam(query: LocationQuery, name: string): string | undefined {
  const param = query[name];
  const queryParam = Array.isArray(param) ? param[0] : param;
  // 'null' query param indicates query has this parameter but the value is empty,
  // e.g. `example.com?param`
  // in this case return empty string
  return queryParam === null ? "" : queryParam;
}

export function reloadAppAtPath(to: RouteLocation) {
  const path = joinURL(import.meta.env.VITE_APP_BASE_SUFFIX, to.fullPath);
  if (globalThis.location.pathname !== path) {
    globalThis.location.href = path;
  } else {
    globalThis.location.reload();
  }
}
